import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip, message } from "antd";
import StatusBadge from "../../Reuseable/StatusBadge";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination";
import DataParser from "../../../utlits/Dataparser";
import LeadSourceService from "../../../Services/LeadSourceService";
import secureLocalStorage from "react-secure-storage";
import { Helmet } from "react-helmet";
import SocketService from "../../../Services/SocketService";
import TableSkeleton from "../../Reuseable/TableSkeleton";

message.config({ zIndex: 1000000001 });

const LeadSource = () => {
  const navigate = useNavigate();
  const [leadSources, setLeadSources] = useState([]);
  const [name, setName] = useState("");
  const [editName, setEditName] = useState("");
  const [editType, setEditType] = useState("inbound");
  const [editId, setEditId] = useState("");
  const [itemToDelete, setItemToDelete] = useState(null);
  const compids = DataParser.CompanyId();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [userPermissions, setuserPermissions] = useState([]);

  const getLeadSource = () => {
    setLoading(true);
    LeadSourceService.getLeadSourceAll(compids)
      .then((res) => {
        const data = res.data.leadsources;
        setLeadSources(data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getLeadSource();
    const upermission = DataParser.CompanyUserPermissions();
    setuserPermissions(upermission);
  }, []);

  useEffect(() => {
    SocketService.connect();
    const companyId = DataParser.CompanyId();
    const handleLeadSourceUpdate = (data) => {
      if (Number(data.company_id) === Number(companyId)) {
        getLeadSource();
      }
    };
    SocketService.on("leadsource_update", handleLeadSourceUpdate);
    return () => {
      SocketService.off("leadsource_update", handleLeadSourceUpdate);
    };
  }, []);

  useEffect(() => {
    if (pageSize > 15) setCurrentPage(1);
  }, [pageSize]);

  const handelPageChange = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const handelDelete = (e, item) => {
    e.preventDefault();
    setItemToDelete(item);
    document.getElementById("openDeleteLeadSourceModal").click();
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    const id = itemToDelete.id;
    setLeadSources((prev) => prev.filter((el) => el.id !== id));
    document.getElementById("closeLeadSourceDeleteModal").click();
    const companyId = DataParser.CompanyId();
    try {
      const res = await LeadSourceService.deleteLeadSource(id, companyId);
      if (res.data === "Un-Athunticated request") {
        secureLocalStorage.removeItem("adminInfo");
        secureLocalStorage.removeItem("admins");
        navigate("/");
      } else {
        message.success("Lead source deleted successfully!");
      }
      getLeadSource();
    } catch (err) {
      console.error("Delete error:", err);
      message.error("Failed to delete lead source. Please try again!");
      getLeadSource();
    }
    setItemToDelete(null);
  };

  const handelEdit = (e, item) => {
    e.preventDefault();
    setEditId(item.id);
    setEditName(item.name);
    setError("");
  };

  const clearCreateState = () => {
    setName("");
    setError("");
  };

  const clearEditState = () => {
    setEditName("");
    setEditId("");
    setError("");
  };

  const handelUpdate = (e) => {
    e.preventDefault();

    if (!editName || editName.trim() === "") {
      setError("Lead source name is required!");
      return;
    }

    LeadSourceService.updateLeadSource(editId, { name: editName.trim() })
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          return;
        }
        if (res.Good === true) {
          message.success("Lead source updated successfully!");
          const link = document.getElementById("closeEditLeadSource");
          if (link) link.click();
          getLeadSource();
        } else {
          message.warning("Could not update lead source. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Update error:", err);
        message.error(
          err.response?.data?.message ||
          "An error occurred while updating the lead source."
        );
      });
  };

  const hadelCreate = (e) => {
    e.preventDefault();

    if (!name || name.trim() === "") {
      setError("Lead source name is required!");
      return;
    }

    LeadSourceService.createLeadSource({ company_id: compids, name: name.trim() })
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          return;
        }
        if (res.Good === true) {
          message.success("Lead source created successfully!");
          const link = document.getElementById("closeCreateLeadSource");
          if (link) link.click();
          setName("");
          getLeadSource();
        } else {
          message.warning("Could not create lead source. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Create error:", err);
        message.error(
          err.response?.data?.message ||
          "An error occurred while creating the lead source."
        );
      });
  };

  const PaginatedData = paginate(leadSources, currentPage, pageSize);

  return (
    <>
      <Helmet>
        <title>Lead Source - Planit</title>
      </Helmet>
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <div className="d-flex align-items-end justify-content-end" style={{ padding: "0 0 12px 0" }}>
                  <div className="d-flex flex-column align-items-end" style={{ gap: "6px" }}>
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                      </li>
                      <li className="breadcrumb-item active">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                      </li>
                      <li className="breadcrumb-item active">Lead Source</li>
                    </ol>
                    {userPermissions.indexOf("departments-create") !== -1 ? (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        style={{ borderRadius: "5px" }}
                        data-bs-toggle="modal"
                        data-bs-target="#createLeadSourceModalDialog"
                      >
                        Create Lead Source
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        disabled
                        style={{ opacity: 0.6, cursor: "not-allowed", borderRadius: "5px" }}
                      >
                        Create Lead Source
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                  <div className="card-body p-0">
                    <div className="table-responsive listing-table-wrapper">
                      <table className="table mb-0 custom-table listing-table">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th>Sr#</th>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <TableSkeleton cols={4} rows={6} />
                          ) : PaginatedData && PaginatedData.length > 0 ? (
                            PaginatedData.map((item, index) => (
                              <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>{item.name}</td>
                                <td>
                                  {userPermissions.indexOf("leadsource-edit") !== -1 ? (
                                    <StatusBadge
                                      item={item}
                                      api={LeadSourceService.statusChange}
                                    />
                                  ) : (
                                    <>
                                      {item.status === "1" ? (
                                        <span className="badge bg-success text-white">Active</span>
                                      ) : (
                                        <span className="badge bg-danger text-white">Deactive</span>
                                      )}
                                    </>
                                  )}
                                </td>
                                <td className="tableset">
                                  {userPermissions.indexOf("leadsource-delete") !== -1 ? (
                                    <Link
                                      to="#"
                                      className="cursor-pointer iconscolor"
                                      onClick={(e) => handelDelete(e, item)}
                                    >
                                      <Tooltip title="Delete Lead Source">
                                        <i className="uil-trash iconscolor" />
                                      </Tooltip>
                                    </Link>
                                  ) : (
                                    <span
                                      className="uil-trash iconscolor text-muted"
                                      style={{ cursor: "not-allowed", opacity: 0.5 }}
                                      title="You don't have permission to delete"
                                    />
                                  )}
                                  {userPermissions.indexOf("leadsource-delete") !== -1 ? (
                                    <Link
                                      to="#"
                                      className="cursor-pointer iconscolor"
                                      onClick={(e) => handelEdit(e, item)}
                                      data-bs-toggle="modal"
                                      data-bs-target="#editLeadSourceModalDialog"
                                    >
                                      <Tooltip title="Edit Lead Source">
                                        <i className="uil-pen iconscolor" />
                                      </Tooltip>
                                    </Link>
                                  ) : (
                                    <span
                                      className="uil-pen iconscolor text-muted"
                                      style={{ cursor: "not-allowed", opacity: 0.5 }}
                                      title="You don't have permission to edit"
                                    />
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                Add your first lead source by clicking the 'Create Lead Source' button.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>

                      {leadSources.length > pageSize && (
                        <div className="d-flex justify-content-center mt-4">
                          <Pagination
                            itemCount={leadSources.length}
                            currentPage={currentPage}
                            pageSize={pageSize}
                            onPageChange={handelPageChange}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Hidden trigger for delete modal */}
        <button id="openDeleteLeadSourceModal" data-bs-toggle="modal" data-bs-target="#deleteLeadSourceModal" style={{ display: "none" }} />

        {/* Delete Confirmation Modal */}
        <div id="deleteLeadSourceModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
          <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
              <div className="modal-header border-0 pb-1">
                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Delete Lead Source</h5>
                <button type="button" className="btn-close" id="closeLeadSourceDeleteModal" data-bs-dismiss="modal" aria-label="Close" onClick={() => setItemToDelete(null)} />
              </div>
              <div className="modal-body pt-2 pb-2">
                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>Are you sure you want to delete this lead source?</p>
                <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                  <i className="uil uil-exclamation-triangle me-1" />
                  This action cannot be undone.
                </p>
              </div>
              <div className="modal-footer border-0 pt-1">
                <button type="button" className="btn btn-danger waves-effect waves-light" onClick={confirmDelete} style={{ borderRadius: "5px", fontSize: "13px" }}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Create modal */}
        <div
          id="createLeadSourceModalDialog"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <form onSubmit={(e) => hadelCreate(e)}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Create Lead Source</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="closeCreateLeadSource"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={clearCreateState}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="LeadSourceName"
                      placeholder=" "
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                        if (e.target.value.trim() !== "") setError("");
                      }}
                    />
                    <label htmlFor="LeadSourceName">Lead Source Name*</label>
                  </div>
                  {error && <small className="text-danger mt-1 d-block">{error}</small>}
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    type="button"
                    onClick={(e) => hadelCreate(e)}
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    + Create Lead Source
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        {/* Edit modal */}
        <div
          id="editLeadSourceModalDialog"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <form onSubmit={(e) => handelUpdate(e)}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Edit Lead Source</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="closeEditLeadSource"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={clearEditState}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="LeadSourceNameEdit"
                      placeholder=" "
                      value={editName}
                      onChange={(e) => {
                        setEditName(e.target.value);
                        if (e.target.value.trim() !== "") setError("");
                      }}
                    />
                    <label htmlFor="LeadSourceNameEdit">Lead Source Name*</label>
                  </div>
                  {error && <small className="text-danger mt-1 d-block">{error}</small>}
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    type="button"
                    onClick={(e) => handelUpdate(e)}
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default LeadSource;
